// About.js
import React from 'react';
import styled from '@xstyled/styled-components';
import { useState } from 'react';
import { sendMessageFunctionEndpoint } from '../../common/Constants'; // Adjust the import path as necessary

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  display: ${({ show }) => (show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;

const Modal = styled.div`
  background: white;
  padding: 20px;
  max-width: 90%;
  width: 400px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
`;

const CloseButton = styled.button`
  float: right;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
`;
// Styled form container
const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

// Styled form row for side-by-side fields
const Row = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

// Styled label and input
const Label = styled.label`
  display: flex;
  flex-direction: column;
  flex: 1;
  font-weight: bold;
  font-size: clamp(12px, 1.5vw, 16px);

  input, textarea {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ccc;
    margin-top: 4px;
    font-size: 1em;
  }

  textarea {
    min-height: 100px;
    resize: vertical;
  }
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-size: 1em;
  transition: background-color 0.3s ease;

  &:hover:enabled {
    background-color: #0056b3;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    color: #666666;
  }
`;

const ContactModal = ({ show, onClose }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  // const [captchaToken, setCaptchaToken] = useState('');
  const [errors, setErrors] = useState({});

  const validateEmail = (email) => {
    // Basic email regex
    return /\S+@\S+\.\S+/.test(email);
  };

  const sendMessage = async (data) => {
    try {
      const response = await fetch(sendMessageFunctionEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      console.log('Message sent successfully:', result);
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!firstName.trim()) newErrors.firstName = 'First name is required';
    if (!lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!message.trim()) newErrors.message = 'Message is required';

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // No errors, submit the form (call your Azure Function here)
      console.log('Submitting:', { firstName, lastName, email, phone, message });
      sendMessage({
        firstName,
        lastName,
        email,
        phone,
        message
      });
      // Clear form
      setFirstName('');
      setLastName('');
      setEmail('');
      setPhone('');
      setMessage('');
      setErrors({});
      onClose(); // Optionally close the modal after submit
    }
  };

  const isFormValid =
    firstName.trim() &&
    lastName.trim() &&
    validateEmail(email) &&
    message.trim();

  return (
    <Overlay show={show}>
      <Modal>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <h2>Contact Form</h2>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Label>
              First Name *
              <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
              {errors.firstName && <span style={{ color: 'red', fontSize: '0.9em' }}>{errors.firstName}</span>}
            </Label>

            <Label>
              Last Name *
              <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
              {errors.lastName && <span style={{ color: 'red', fontSize: '0.9em' }}>{errors.lastName}</span>}
            </Label>
          </Row>
          <Row>
            <Label>
              Email *
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
              {errors.email && <span style={{ color: 'red', fontSize: '0.9em' }}>{errors.email}</span>}
            </Label>
            <Label>
              Phone
              <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </Label>
          </Row>
          <Label>
            Message *
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} />
            {errors.message && <span style={{ color: 'red', fontSize: '0.9em' }}>{errors.message}</span>}
          </Label>
          {/* <SubmitButton type="submit" disabled={!captchaToken}>Send</SubmitButton> */}
          <SubmitButton type="submit" disabled={!isFormValid}>Send</SubmitButton>
        </Form>
      </Modal>


    </Overlay>
  );
};

export default ContactModal;
